import React, { createContext, useState } from 'react';

export const CsvDataContext = createContext();

export const CsvDataProvider = ({ children }) => {
  const [csvData, setCsvData] = useState([]);

  return (
    <CsvDataContext.Provider value={{ csvData, setCsvData }}>
      {children}
    </CsvDataContext.Provider>
  );
};
